module.exports = __webpack_public_path__ + "img/logo-sepac-compagri.ca0934fe.jpg";